class MobileNav extends HTMLElement {
    constructor() {
        super();

        const thisElement = this

        let megamenuTrigger = this.querySelectorAll('.js-megamenu-trigger');

        megamenuTrigger.forEach((el) => {
            let thisMegamenu = el.nextElementSibling;

            el.addEventListener('click', function () {
                thisElement.open(thisMegamenu);
            });

            let megaMenuBack = thisMegamenu.querySelector('.js-megamenu-back');

            megaMenuBack.addEventListener('click', function () {
                thisElement.close(thisMegamenu);
            });
        });
    }

    // Open megamenu
    open(megamenu) {
        megamenu.classList.add('mobile-nav__megamenu--active');
    }

    // //Close megamenu
    close(megamenu) {
        megamenu.classList.remove('mobile-nav__megamenu--active');
    }
}

customElements.define('mobile-nav', MobileNav);
